var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlockchainIndexed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_11130_23893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
    fill: "#D7EDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0.200195C18.517 0.200195 23.7998 5.48304 23.7998 12C23.7998 18.517 18.517 23.7998 12 23.7998C5.48304 23.7998 0.200195 18.517 0.200195 12C0.200195 5.48304 5.48304 0.200195 12 0.200195Z",
    stroke: "#A3D6FF",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11130_23893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.9408 9.66641L12.0008 11.9997M12.0008 11.9997L16.0608 9.66641M12.0008 11.9997L12.0008 16.6664M16.2008 10.133C16.2006 9.96936 16.1574 9.80861 16.0755 9.6669C15.9936 9.5252 15.8759 9.40753 15.7341 9.32569L12.4674 7.45903C12.3256 7.37711 12.1646 7.33398 12.0008 7.33398C11.8369 7.33398 11.676 7.37711 11.5341 7.45903L8.26745 9.32569C8.1257 9.40753 8.00797 9.5252 7.92606 9.6669C7.84415 9.80861 7.80095 9.96936 7.80078 10.133V13.8664C7.80095 14.03 7.84415 14.1908 7.92606 14.3325C8.00797 14.4742 8.1257 14.5919 8.26745 14.6737L11.5341 16.5404C11.676 16.6223 11.8369 16.6654 12.0008 16.6654C12.1646 16.6654 12.3256 16.6223 12.4674 16.5404L15.7341 14.6737C15.8759 14.5919 15.9936 14.4742 16.0755 14.3325C16.1574 14.1908 16.2006 14.03 16.2008 13.8664V10.133Z",
    stroke: "#0075D1",
    strokeWidth: 0.933333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_11130_23893",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.483999 0 0 0 0 0.772671 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_11130_23893"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11130_23893"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.2,
    height: 11.2,
    fill: "white",
    transform: "translate(6.40039 6.40039)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockchainIndexed);
export default __webpack_public_path__ + "static/media/blockchain_Indexed.6a69f0be71c25e85261b625665605004.svg";
export { ForwardRef as ReactComponent };